﻿import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ParticipantDetailsComponent } from './participant-details/participant-details.component';
import { PhoneVerificationComponent } from './phone-verification/phone-verification.component';
import { FillSurveysRoutingModule } from './fill-surveys-routing.module';
import { SurveyDetailsComponent } from './survey-details/survey-details.component';
;

@NgModule({
    declarations: [
        PhoneVerificationComponent,
        SurveyDetailsComponent,
        ParticipantDetailsComponent
    ],
    imports: [
        CommonModule,
        CoreModule,
        SharedModule,
        FillSurveysRoutingModule,
        ReactiveFormsModule,       
    ],
})
export class FillSurveysModule { }